module.exports = __webpack_public_path__ + "img/Large-Bevel-Attachment-48.701e6927.png";